import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isString from 'lodash/isString';
import { Icon, Spinner } from 'xm-spark';

import styles from './QuickStartProgressSection.module.scss';

const SectionIcon = ({ sectionIcon }) =>
  isString(sectionIcon) ? (
    <Icon type={sectionIcon} className={styles.icon} />
  ) : (
    <Icon type="svg" className={styles.icon}>
      {sectionIcon}
    </Icon>
  );

export default function QuickStartProgressSection({
  isComplete,
  isLoading,
  section,
  testIdPrefix,
}) {
  const { icon, sectionId } = section;

  return (
    <div
      className={classnames(styles.outer, {
        [styles.active]: isComplete,
      })}
      data-testid={`${testIdPrefix}__progressSection--${sectionId}`}
    >
      {isLoading ? (
        <Spinner
          className={styles.spinner}
          centered
          data-testid={`${testIdPrefix}__progressSection--spinner`}
        />
      ) : (
        <SectionIcon
          sectionIcon={icon}
          data-testid={`${testIdPrefix}__progressSectionIcon--${sectionId}`}
        />
      )}
    </div>
  );
}

QuickStartProgressSection.propTypes = {
  isComplete: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  section: PropTypes.shape().isRequired,
  testIdPrefix: PropTypes.string.isRequired,
};

QuickStartProgressSection.displayName = 'QuickStartProgressSection';
